class SHTVariantSelector extends HTMLElement {
  constructor() {
    super();
    console.log(123);
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);

    this.elms = {
      radio_elms: this.$$(".js-variant-radio-item"),
      radio_container_elms: this.$$(".js-variant-radio-container"),
      form: SHTHelper.qs(`#productForm-${this.dataset.section}`),
      price: SHTHelper.qs(`#productPrice-${this.dataset.section}`),
      installment_form: SHTHelper.qs(`#productFormInstallment-${this.dataset.section}`),
      product_form: SHTHelper.qs(`sht-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: SHTHelper.qs(`#inventoryTracking-${this.dataset.section}`),
      variant_picker: SHTHelper.qs(`#variantPicker-${this.dataset.section}`),
      quantity_input: SHTHelper.qs(`#productQuantity-${this.dataset.section}`),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`),
      thumb_carousel: SHTHelper.qs(`.js-product-media-wrapper[data-section="${this.dataset.section}"]`),
      product_sticky_info: SHTHelper.qs(`#productStickyInfo-${this.dataset.section}`),
      carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
      variant_options: this.$$(".js-variant-option-value"),
      sku: SHTHelper.qs(`#sku-${this.dataset.section}`),
    };

    this.price_selector = `#productPrice-${this.dataset.section}`;
    this.inventory_tracking_selector = `#inventoryTracking-${this.dataset.section}`;
    this.variant_picker_selector = `#variantPicker-${this.dataset.section}`;
    this.quantity_input_selector = `#productQuantity-${this.dataset.section}`;
    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;
    this.sku_selector = `#sku-${this.dataset.section}`;
    this.selected_variants = null;

    this.variant_data = null;

    this.setSelectedVariants();
    this.setCurrentVariant();
    this.updateProductStickyInfo();
    //this.updateSelectedVariantsOnOptionName();
    if (this.select_type == "dropdown") {
      this.updateSelectedVariantsOnOptionNameByDropDown();
    } else {
      this.updateSelectedVariantsOnOptionName();
    }
    this.bindEventHandlers();
    this.setUnavailableOptions();
  }

  connectedCallback() {
    this.init();
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.addEventListener("change", this.onVariantChangeHandle.bind(this));
  }

  onVariantChangeHandle() {
    this.setSelectedVariants();
    this.setCurrentVariant();
    this.toggleAddButton(true, "", false);
    this.toggleAddButtonSticky(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (this.select_type == "dropdown") {
      this.updateVariantStatuses();
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.toggleAddButtonSticky(true, "", true);
      this.setUnavailable();
      if (this.select_type == "dropdown") {
        this.updateSelectedVariantsOnOptionNameByDropDown();
      } else {
        this.updateSelectedVariantsOnOptionName();
      }
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setActiveMedia();
      this.setUnavailableOptions();
    }
  }

  updateVariantStatuses() {
    const selected_option_one_variants = this.variant_data.filter(variant => this.querySelector(":checked").value === variant.option1);

    const input_wrappers = [...this.querySelectorAll(".js-selectbox-wrapper")];

    input_wrappers.forEach((option, index) => {
      if (index === 0) return;
      const option_inputs = [...option.querySelectorAll("option")];

      const previous_option_selected = input_wrappers[index - 1].querySelector(":checked").value;

      const available_option_inputs_value = selected_option_one_variants.filter(variant => variant.available && variant[`option${index}`] === previous_option_selected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setSelectOptionAvailability(option_inputs, available_option_inputs_value);

      const radioInputs = [...option.querySelectorAll(`input[type="radio"]`)];
      if (radioInputs.length > 0) {
        this.setColorSwatchSelectOptionAvailability(radioInputs, available_option_inputs_value);
      }
    });
  }

  setSelectOptionAvailability(option_inputs, available_option_inputs_value) {
    option_inputs.forEach(input => {
      if (available_option_inputs_value.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = SHTLanguage.product.PRODUCT_UNAVAILABLE_WITH_OPTION.replace("[value]", input.getAttribute("value"));
      }
    });
  }

  setColorSwatchSelectOptionAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      let parent = this.querySelector(`div.js-variant-option-value[data-value="${input.getAttribute("data-variant-value").replace(/"/g, '\\"')}"]`);
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        parent && parent.classList.remove("product-option--unavailable");
      } else {
        parent && parent.classList.add("product-option--unavailable");
      }
    });
  }

  updateOptionState(available) {
    this.$$(".product-option--sold-out").forEach(e => {
      e.classList.remove("product-option--sold-out");
    });
    if (!available) {
      this.selected_variants.forEach(e => {
        let selected = this.$(`.js-variant-item[data-variant-value="${e.replace(/"/g, '\\"')}"]`);
        if (selected) {
          selected.closest(".js-variant-option-value")?.classList.add("product-option--sold-out");
        }
      });
    }
  }

  updateSelectedVariantsOnOptionNameByDropDown() {
    this.selected_variants.forEach((e, index) => {
      let selectedVariant = `${e}-${index}`;
      let selected = this.$(`.js-variant-select-item .js-variant-item[data-variant-value="${selectedVariant.replace(/"/g, '\\"')}"]`);
      if (selected) {
        let variant_name = selected.getAttribute("data-variant-name");

        let variant_need_to_updated = this.$(`.js-variant-select-option-name[data-option-name="${variant_name.replace(/"/g, '\\"')}"]`);
        if (variant_need_to_updated) {
          variant_need_to_updated.innerHTML = e;
        }
      }
    });
  }

  updateSelectedVariantsOnOptionName() {
    this.selected_variants.forEach((e, index) => {
      let selectedVariant = `${e}-${index}`;
      let selected = this.$(`.js-variant-item[data-variant-value="${selectedVariant.replace(/"/g, '\\"')}"]`);
      if (selected) {
        let variant_name = selected.getAttribute("name");

        let variant_need_to_updated = this.$(`.js-variant-radio-option-name[data-option-name="${variant_name.replace(/"/g, '\\"')}"]`);

        if (variant_need_to_updated) {
          variant_need_to_updated.innerHTML = e;
        }
      }
    });
  }

  updateProductStickyInfo() {
    if (this.elms.product_sticky_info) {
      this.elms.product_sticky_info.querySelector(".js-product-sticky-info-variant").innerHTML = this.currentVariant.title;
      if (this.elms.price) {
        this.elms.product_sticky_info.querySelector(".js-product-sticky-info-price").innerHTML = this.elms.price.innerHTML;
      }
      this.elms.product_sticky_info.querySelector(".js-quantity-input").value = 1;

      this.elms.product_sticky_info.querySelector(`[name="id"]`).value = this.currentVariant.id;
    }
  }

  removeErrorMessage() {
    if (this.elms.product_form) this.elms.product_form.handleErrorMessage();
  }

  updatePickupAvailability() {
    const pickUpAvailability = SHTHelper.qs("sht-pickup-avail");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.classList.remove("d-block");
      pickUpAvailability.classList.add("d-none");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then(response => response.text())
      .then(responseText => {
        let markup = new DOMParser().parseFromString(responseText, "text/html");

        //Update variant picker
        // let variantPickerDestination = this.elms.variant_picker;
        // let variantPickerSource = markup.querySelector(
        //   this.variant_picker_selector
        // );

        // if (variantPickerDestination && variantPickerSource)
        //   variantPickerDestination.innerHTML = variantPickerSource.innerHTML;

        //Update variant picker

        //Update Inventory Tracking
        let inventoryTrackingDestination = this.elms.inventory_tracking;
        let inventoryTrackingSource = markup.querySelector(this.inventory_tracking_selector);

        if (inventoryTrackingDestination) {
          inventoryTrackingDestination.innerHTML = "";
          if (inventoryTrackingSource) {
            inventoryTrackingDestination.innerHTML = inventoryTrackingSource.innerHTML;
          }
        }
        //Update Inventory Tracking

        //Update Price
        let priceDestination = this.elms.price;
        let priceSource = markup.querySelector(this.price_selector);

        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
        }

        if (this.elms.price) {
          this.elms.price.classList.remove("visibility-hidden");
        }
        //Update Price
        //Update SKU
        let skuDestination = this.elms.sku;
        let skuSource = markup.querySelector(this.sku_selector);

        if (skuDestination) {
          skuDestination.innerHTML = "";
          if (skuSource) {
            skuDestination.innerHTML = skuSource.innerHTML;
          }
        }
        //Update SKU
        //Update Quantity Input
        this.elms.quantity_input.querySelector(".js-quantity-input").value = 1;
        /*let quantityInputDestination = this.elms.quantity_input;
        let quantityInputSource = markup.querySelector(
          this.quantity_input_selector
        );

        if (quantityInputDestination && quantityInputSource) {
          quantityInputDestination.innerHTML = quantityInputSource.innerHTML;
        }*/

        //if (this)
        //Update Quantity Input

        //Update Product Quick Info
        this.updateProductStickyInfo();
        if (this.select_type == "dropdown") {
          this.updateSelectedVariantsOnOptionNameByDropDown();
        } else {
          this.updateSelectedVariantsOnOptionName();
        }
        //this.updateOptionState(this.currentVariant.available);
        //Update Product Quick Info
        //Update SlideShow
        if (this.elms.slideshow.hide_variant == "false") {
          let slideshowDestination = this.elms.slideshow;
          let slideshowSource = markup.querySelector(this.slideshow_selector);
          if (slideshowDestination && slideshowSource) {
            slideshowDestination.innerHTML = slideshowSource.innerHTML;
          }
        }
        //Update SlideShow

        this.toggleAddButton(!this.currentVariant.available, SHTLanguage.product.PRODUCT_SOLD_OUT);

        this.toggleAddButtonSticky(!this.currentVariant.available, SHTLanguage.product.PRODUCT_SOLD_OUT);
      });
  }

  updateVariantInput() {
    const productForms = [this.elms.form, this.elms.installment_form];

    productForms.forEach(productForm => {
      if (productForm) {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  setActiveMedia() {
    if (this.currentVariant.featured_media) {
      let mediaId = this.currentVariant.featured_media.id;

      let activeMedia = this.elms.slideshow.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`);

      let activeThumb = this.elms.slideshow.querySelector(`sht-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`);

      if (!window.matchMedia("(max-width: 768px)").matches) {
        this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
          element.classList.remove("d-block");
          this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
        });

        this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        activeMedia.classList.add("d-block");
        if (this.elms.slideshow.hide_variant == "true") {
          activeMedia.classList.remove("d-none");
        }
      } else {
        this.elms.carousel.querySelector(".js-carousel-items").scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });
      }

      if (activeThumb) {
        activeThumb.classList.add("is-active-item");
        this.elms.thumb_carousel?.querySelector(".js-carousel-items").scrollTo({
          top: activeThumb.offsetTop,
          behavior: "auto",
        });
      }

      this.elms.slideshow.pauseAllVideo();
    }
  }

  setUnavailable() {
    let form = this.elms.form;
    let inventoryTracking = this.elms.inventory_tracking;
    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");
    if (!addBtn) return;
    inventoryTracking.setAttribute('hidden', 'true');
    addBtnText.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE;
    if (this.elms.price) this.elms.price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variant_data = this.variant_data || JSON.parse(this.$('[type="application/json"]').textContent);

    this.variant_data.map(e => {
      e.my_options = [];
      e.options.forEach((elm, index) => {
        e.my_options.push(`${elm}-${index}`);
      });
    });

    return this.variant_data;
  }

  setCurrentVariant() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.selected_variants[index] === option;
        })
        .includes(false);
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let form = this.elms.form;
    let inventoryTracking = this.elms.inventory_tracking;
    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");

    if (!addBtn) return;
    inventoryTracking.removeAttribute('hidden');
    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
    }

    if (!modifyClass) return;
  }

  toggleAddButtonSticky(disable = true, text, modifyClass = true) {
    let form = SHTHelper.qs(`#productStickyForm-${this.dataset.section}`);

    if (!form) return;
    let addBtn = form.querySelector(`.js-product-form-submit-btn`);
    let addBtnText = addBtn.querySelector(`.js-product-form-submit-btn-text`);

    if (!addBtn) return;

    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
    }

    if (!modifyClass) return;
  }

  toggleUnavailableOptions(unavailable = false) {
    this.elms.variant_options.forEach(element => {
      element.classList.toggle("product-option--unavailable", unavailable);
    });
  }

  setUnavailableOptions() {
    if (this.select_type == "dropdown") return;
    this.toggleUnavailableOptions(false);
    this.variant_data = this.variant_data || this.getVariantData();

    this.selected_variant_id = this.elms.form.querySelector('input[name="id"]').value;

    this.current_variant = this.variant_data.find(variant => variant.id === Number(this.selected_variant_id));
    //console.log(this.current_variant);
    const {
      available: currentVariantAvailable,
      options,
      my_options,
      options: { length: maxOptions },
    } = this.current_variant;

    if (maxOptions > 2) {
      let keys = Object.keys(options);
      let matchVariants = [];

      //array combinations algorithm
      // Find all variants that have the same value as the selected variant
      for (let i = 0; i < maxOptions; i++) {
        for (let j = i + 1; j < maxOptions; j++) {
          if (keys[i] && keys[j]) {
            let tmpMatchVariants = this.variant_data.filter(v => {
              return v.my_options[keys[i]] === this.current_variant.my_options[keys[i]] && v.my_options[keys[j]] === this.current_variant.my_options[keys[j]] && v.available == true;
            });
            matchVariants = [...matchVariants, ...tmpMatchVariants];
          }
        }
      }

      let tmpValidVariants = [];
      let validVariants = [];
      if (matchVariants.length) {
        // merger the match result with current variant

        matchVariants = [...matchVariants, this.current_variant];

        // get variants values only from the match result
        matchVariants.forEach(matchVariant => {
          let { my_options: tmpOptions } = matchVariant;
          tmpValidVariants = [...tmpValidVariants, ...tmpOptions];
        });

        // make valid variants unique
        validVariants = [...new Set(tmpValidVariants)];

        // get rid of current variant out of valid variants if its available status is false
        if (currentVariantAvailable == false) {
          validVariants = validVariants.filter(x => !my_options.includes(x));
        }
      }

      this.toggleUnavailableOptions(true);

      if (validVariants.length) {
        validVariants.forEach(e => {
          this.$(`[data-value="${e.replace(/"/g, '\\"')}"]`) && this.$(`[data-value="${e.replace(/"/g, '\\"')}"]`).classList.toggle("product-option--unavailable", false);
        });
      }
    } else if (maxOptions > 1) {
      let matchVariants = [];
      let tmpValidVariants = [];
      let validVariants = [];
      for (let i = 0; i < maxOptions; i++) {
        let tmpMatchVariants = this.variant_data.filter(v => {
          return v.my_options[i] === this.current_variant.my_options[i] && v.available == true;
        });
        matchVariants = [...matchVariants, ...tmpMatchVariants];
      }
      if (matchVariants.length) {
        // merger the match result with current variant
        matchVariants = [...matchVariants, this.current_variant];

        // get variants values only from the match result
        matchVariants.forEach(matchVariant => {
          let { my_options: tmpOptions } = matchVariant;
          tmpValidVariants = [...tmpValidVariants, ...tmpOptions];
        });

        // make valid variants unique
        validVariants = [...new Set(tmpValidVariants)];

        // get rid of current variant out of valid variants if its available status is false
        if (currentVariantAvailable == false) {
          validVariants = validVariants.filter(x => !my_options.includes(x));
        }
      }

      this.toggleUnavailableOptions(true);
      if (validVariants.length) {
        validVariants.forEach(e => {
          this.$(`[data-value="${e.replace(/"/g, '\\"')}"]`) && this.$(`[data-value="${e.replace(/"/g, '\\"')}"]`).classList.toggle("product-option--unavailable", false);
        });
      }

      // if (validVariants.length) {
      //   validVariants.forEach(e => {
      //     let tmpValidVariants = this.$$(`[data-value="${e.replace(/"/g, '\\"')}"]`);
      //     tmpValidVariants.forEach(elm => {
      //       elm.classList.toggle("product-option--unavailable", false);
      //     });
      //     //
      //   });
      // }
    } else {
      let tmpValidVariants = [];
      let validVariants = [];
      let matchVariants = this.variant_data.filter(v => {
        return v.available == true;
      });

      if (matchVariants.length) {
        matchVariants = [...matchVariants, this.current_variant];
      }

      matchVariants.forEach(matchVariant => {
        let { my_options: tmpOptions } = matchVariant;
        tmpValidVariants = [...tmpValidVariants, ...tmpOptions];
      });
      validVariants = [...new Set(tmpValidVariants)];
      if (currentVariantAvailable == false) {
        validVariants = validVariants.filter(x => !my_options.includes(x));
      }
      this.toggleUnavailableOptions(true);

      if (validVariants.length) {
        validVariants.forEach(e => {
          this.$(`[data-value="${e.replace(/"/g, '\\"')}"]`) && this.$(`[data-value="${e.replace(/"/g, '\\"')}"]`).classList.toggle("product-option--unavailable", false);
        });
      }
    }
    return true;
  }
}

class SHTVariantRadios extends SHTVariantSelector {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.select_type = "button";
  }

  setSelectedVariants() {
    let selectors = Array.from(this.$$(".js-variant-radio-container"));
    this.selected_variants = selectors.map(selector => {
      return Array.from(selector.querySelectorAll(".js-variant-radio-item")).find(radio => radio.checked).value;
    });
  }
}

customElements.define("sht-variant-radios", SHTVariantRadios);

class SHTVariantSelects extends SHTVariantSelector {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.select_type = "dropdown";
  }

  //updateOptions
  setSelectedVariants() {
    this.selected_variants = Array.from(this.$$(".js-variant-select-item"), select => select.value);
  }
}
customElements.define("sht-variant-selects", SHTVariantSelects);

class SHTVariantSwatchSelect extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach(radio => {
      radio.addEventListener("click", e => {
        e.preventDefault();
        Array.from(this.radios, input => {
          input.checked = false;
        });

        setTimeout(() => {
          e.target.checked = true;
        });
        if (this.select_element) {
          let option = this.select_element.querySelector(`option[value="${e.target.value.replace(/"/g, '\\"')}"]`);
          option.selected = true;
          this.select_element.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }
      });
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-variant-swatch-select", SHTVariantSwatchSelect);

class SHTProductForm extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      quantity_input_container: SHTHelper.qs(`#productQuantity-${this.dataset.section}`),
      submit_btn_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-submit-btn"),
      error_wrapper_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-wrapper"),
      error_message_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-message"),
      spinner_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-spinner"),
      sticky_header: SHTHelper.qs("sht-sticky-header"),
      header: SHTHelper.qs("sht-header"),
      announcement_bar: SHTHelper.qs("sht-ann-bar"),
      header_cart_status: SHTHelper.qs("#headerCartStatus"),
    };

    this.cartNotiType = document.body.getAttribute("data-cart-show-type");
    this.cartType = document.body.getAttribute("data-cart-type");

    this.elms.form.querySelector("[name=id]").disabled = false;

    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");
    this.cardRecipientForm = SHTHelper.qs("sht-gift-card-recipient-form");

    this.bindEventHandlers();
  }

  connectedCallback() {
    this.init();
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    // this.cartNotification &&
    //   this.cartNotification.setActiveElement(document.activeElement);
  }

  onSubmitHandler(e) {
    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading")) return;
    this.hideErrorMessage();

    this.elms.submit_btn.setAttribute("aria-disabled", true);
    this.elms.submit_btn.setAttribute("disabled", true);
    this.elms.submit_btn.classList.add("loading");

    if (this.elms.submit_btn_sticky) {
      this.elms.submit_btn_sticky.setAttribute("aria-disabled", true);
      this.elms.submit_btn_sticky.setAttribute("disabled", true);
      this.elms.submit_btn_sticky.classList.add("loading");
    }

    this.elms.spinner.classList.remove("hidden");
    if (this.elms.spinner_sticky) {
      this.elms.spinner_sticky.classList.remove("hidden");
    }
    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove("header-cart-status--animate");
    }
    let sections = [];
    if (this.cartNotification) {
      sections = this.cartNotification.getSectionsToRender();
    }
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }

    let formData = new FormData(this.elms.form);
    if (sections.length) {
      formData.append(
        "sections",
        sections.map(section => section.id)
      );
    }
    formData.append("sections_url", window.location.pathname);
    SHTHelper.fetchConfigHTTP.body = formData;
    let elementToFocus = typeof e.submitter != "undefined" ? this.elms.submit_btn : this.elms.submit_btn_sticky;

    fetch(`${routes.cart_add_url}`, SHTHelper.fetchConfigHTTP)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description, response?.message);
          return;
        }

        if (this.elms.sticky_header) {
          if (this.elms.sticky_header.dataset.isEnabled) {
            this.elms.sticky_header.reveal();
          }
        }

        switch (this.cartNotiType) {
          case "show_popup_noti":
            this.handleShowNotification(response, elementToFocus);
            break;
          case "show_drawer":
            this.handleShowDrawer(response, elementToFocus);
            break;
        }

        if (this.elms.quantity_input_container && this.elms.quantity_input_container.dataset.show == "add-to-cart") {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }

        if (this.cardRecipientForm) {
          this.cardRecipientForm.resetRecipientForm();
        }

        if (!this.elms.header) {
          window.location.assign(window.routes.cart_url);
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.elms.submit_btn.classList.remove("loading");
        this.elms.submit_btn.removeAttribute("aria-disabled");
        this.elms.submit_btn.removeAttribute("disabled");

        if (this.elms.submit_btn_sticky) {
          this.elms.submit_btn_sticky.classList.remove("loading");
          this.elms.submit_btn_sticky.removeAttribute("aria-disabled");
          this.elms.submit_btn_sticky.removeAttribute("disabled");
        }

        this.elms.spinner.classList.add("hidden");
        if (this.elms.spinner_sticky) {
          this.elms.spinner_sticky.classList.add("hidden");
        }
      });
  }

  handleShowNotification(response, elementToFocus) {
    if (this.cartNotification) {
      this.cartNotification.renderContents(response, true, elementToFocus);
    }
    if (this.cartDrawerForm) {
      this.cartDrawerForm.renderContents(response);
    }
  }

  handleShowDrawer(response, elementToFocus) {
    if (this.cartType === "drawer") {
      this.cartNotification?.renderContents(response, false);
      this.cartDrawerForm?.renderContents(response);
      this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage();
      this.cartDrawer?.openDrawer(elementToFocus);
    } else if (this.cartType === "page") {
      this.cartNotification?.renderContents(response, false);
      window.location.assign(window.routes.cart_url);
    }
  }

  hideErrorMessage() {
    this.elms.error_wrapper.toggleAttribute("hidden", true);
    if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
      this.elms.error_wrapper_sticky.toggleAttribute("hidden", true);
    }
  }
  handleErrorMessage(errorMessage = false, message = "") {
    if (errorMessage) {
      if (typeof errorMessage == "string") {
        this.elms.error_wrapper.toggleAttribute("hidden", !errorMessage);

        if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
          this.elms.error_wrapper_sticky.toggleAttribute("hidden", !errorMessage);
        }
        this.elms.error_message.textContent = errorMessage;
        if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
          this.elms.error_message_sticky.textContent = errorMessage;
        }
      }

      if (this.cardRecipientForm && typeof errorMessage == "object") {
        this.cardRecipientForm.handleErrorMessage(errorMessage, message);
      }
    }
  }
}

customElements.define("sht-prd-frm", SHTProductForm);
class SHTStickyProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.is_enabled = this.dataset.isEnabled;

    this.section_id = this.dataset.sectionId;

    this.sticky = this.$(".js-sticky-product-info");
    this.sticky_element = SHTHelper.qs(`#productStickyInfo-${this.section_id}`);
    this.current_scroll_top = 0;
    this.container_height = 0;
    this.sticky_bounds = {};
    this.style_sticky = window.getComputedStyle(this.sticky);
    this.style_sticky_margin_bottom = parseInt(this.style_sticky.marginBottom, 0);
    this.container = SHTHelper.qs(`#${this.section_id}`);
    this.footer_element = document.querySelector(".js-footer");
    this.container_padding_top = parseInt(window.getComputedStyle(this.container).getPropertyValue("padding-top"));

    this.bindEventHandlers();
  }
  createObserver() {
    this.sticky_bounds = this.sticky.getBoundingClientRect();
  }

  bindEventHandlers() {
    if (this.is_enabled == "false") return false;
    window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
  }

  onScrollHandle() {
    let maxScrollTop = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    let intersection_point = this.footer_element !== null ? maxScrollTop - this.footer_element.offsetHeight : maxScrollTop + 10;

    let sticky_top = this.sticky.offsetTop + this.sticky.offsetHeight + this.style_sticky_margin_bottom + this.container.offsetTop + this.container_padding_top;

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    let isBottom = Math.ceil(scrollTop) >= intersection_point ? true : false;
    let percent = 1 - sticky_top / scrollTop;

    if (scrollTop > this.current_scroll_top && percent >= 0 && !isBottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop > this.current_scroll_top && percent >= 0 && isBottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.current_scroll_top && percent >= 0 && !isBottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (percent < 0 && !isBottom) {
      requestAnimationFrame(this.reset.bind(this));
    } else {
    }

    this.current_scroll_top = scrollTop;
  }

  connectedCallback() {
    //if (this.is_enabled == "false") return false;
    // this.createObserver();

    this.init();
  }

  hide() {
    this.sticky_element.classList.remove("opacity-1");
    this.sticky_element.classList.add("hidden-xs", "opacity-0");
  }

  reveal() {
    this.sticky_element.classList.add("opacity-1");
    this.sticky_element.classList.remove("hidden-xs", "opacity-0");
  }
  reset() {
    this.sticky_element.classList.remove("opacity-1");
    this.sticky_element.classList.add("hidden-xs", "opacity-0");
  }
  /**
   * When the element is removed from the DOM, the disconnectedCallback method is triggered
   */
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandle.bind(this));
  }
}

customElements.define("sht-sticky-prd-info", SHTStickyProductInfo);

class SHTQuantityInputSticky extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.input = this.$(`[name="quantity"]`);
    this.orgInput = SHTHelper.qs(`sht-qty-inp #${this.dataset.srcInputSelector}`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.$$("button").forEach(button => button.addEventListener("click", this.onButtonClickHandle.bind(this)));

    this.orgInput.addEventListener("change", () => {
      this.input.value = this.orgInput.value;
    });
  }
  connectedCallback() {
    this.init();
  }
  onButtonClickHandle(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.orgInput.value = this.input.value;
    }
  }
}

customElements.define("sht-qty-inp-sticky", SHTQuantityInputSticky);

class SHTProductFormSticky extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      org_form: SHTHelper.qs(`sht-prd-frm #${this.dataset.srcFrmSelector}`),
    };
    this.bindEventHandlers();
  }
  connectedCallback() {
    this.init();
  }
  bindEventHandlers() {
    this.elms.submit_btn.addEventListener("click", this.onClickSubmitButtonHandle.bind(this));

    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();
    return;
  }

  onClickSubmitButtonHandle() {
    this.elms.org_form.dispatchEvent(new Event("submit", { bubble: true }));
  }
}

customElements.define("sht-prd-frm-sticky", SHTProductFormSticky);

if (!customElements.get("sht-zoom")) {
  class SHTZoom extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.image = this.$(".js-zoom-item");

      this.container = SHTHelper.qs(`#${this.dataset.containerId}`);
      this.image_natural_dimension = {};
      this.container_dimension = {};
      this.rendered_aspect_ratio = {};
      this.image_dimension = {};
      this.is_able_to_zoom = true;

      this.bindEventHandlers();
    }

    init() {
      // this.getImageNaturalDimension();
      this.getImageDimension();
      this.getContainerDimension();
      let tmpSrc = this.image.src;
      let tmpSrcset = this.image.srcset;
      this.image.scr = tmpSrc;
      this.image.srcset = tmpSrcset;
      //this.calculateRenderedAspectRatio();

      // let isAbleToZoom = this.ableToZoom();
      // if (!isAbleToZoom) {
      //   this.image.style.cursor = "default";
      //   this.is_able_to_zoom = false;
      // }
      // this.bindEventHandlers();
    }

    ableToZoom() {
      if (this.rendered_aspect_ratio.container <= this.rendered_aspect_ratio.image || (this.image_natural_dimension.width <= this.container_dimension.width && this.image_natural_dimension.height <= this.container_dimension.height)) return false;

      return true;
    }

    bindEventHandlers() {
      this.image.addEventListener("click", e => {
        e.preventDefault();
        // let offsetX = 0;
        // let offsetY = 0;
        // e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        // e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);

        let isZoomed = this.image.hasAttribute("zoomed");

        if (!isZoomed) {
          this.zoomIn();
        } else {
          this.zoomOut();
        }
      });
    }

    zoomIn() {
      const mediaQuery = window.matchMedia("(max-width: 459px)");
      this.image.style.height = "auto";
      this.image.style.objectFit = "unset";
      this.image.setAttribute("zoomed", true);
      this.image.style.cursor = "zoom-out";
      if (mediaQuery.matches) {
        this.image.style.width = "150%";
        this.image.style.maxWidth = "unset";
      } else {
        this.image.style.width = "100%";
      }

      if (this.image.offsetHeight <= this.container_dimension.height) {
        this.classList.add("d-flex", "fd-column", "center-xs");
      }
      this.container.classList.add("o-scroll");
      this.container.scrollTo({
        top: this.container.scrollHeight / 2 - this.container.offsetHeight / 2,
        behavior: "auto",
      });

      if (mediaQuery.matches) {
        this.container.scrollTo({
          left: this.container.scrollWidth / 2 - this.container.offsetWidth / 2,
          behavior: "auto",
        });
      }
    }

    zoomOut() {
      this.image.style.width = "100%";
      this.image.style.height = "100%";
      this.image.style.objectFit = "contain";
      this.image.removeAttribute("zoomed");
      this.image.style.cursor = "zoom-in";

      this.classList.remove("d-flex", "fd-column", "center-xs");
      this.container.classList.remove("o-scroll");
      this.image.style.maxWidth = null;
    }

    reset() {
      this.zoomOut();
    }

    calculateRenderedAspectRatio() {
      this.rendered_aspect_ratio = {
        image: this.image_natural_dimension.width / this.image_natural_dimension.height,
        container: this.container_dimension.width / this.container_dimension.height,
      };
    }

    getImageNaturalDimension() {
      this.image_natural_dimension = {
        width: parseInt(this.image.getAttribute("width")),
        height: parseInt(this.image.getAttribute("height")),
      };
    }

    getImageDimension() {
      this.image_dimension = {
        width: this.image.offsetWidth,
        height: this.image.offsetHeight,
      };
    }

    getContainerDimension() {
      this.container_dimension = {
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      };
    }
  }
  customElements.define("sht-zoom", SHTZoom);
}

if (!customElements.get("sht-gallery-slide")) {
  class SHTGallerySlide extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = SHTHelper.qs(`sht-dialog#${this.dataset.galleryDialogId}`);
      this.mediaId = this.dataset.mediaId;
      this.zoomElement = this.$("sht-zoom");
      this.gallery = this.closest("sht-gallery");
    }

    init() {
      this.dialog.addEventListener("closing", e => {
        this.classList.add("d-none");
        this.classList.remove("is-active-gallery-slide", "d-flex");
        this.zoomElement && this.zoomElement.reset();
        this.gallery.pauseAllVideo();
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }

  customElements.define("sht-gallery-slide", SHTGallerySlide);
}

if (!customElements.get("sht-gallery-slides")) {
  class SHTGallerySlides extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.gallery = this.closest("sht-gallery");
      this.dialog = SHTHelper.qs(`sht-dialog#${this.gallery.dataset.galleryDialogId}`);
      this.slides = this.$$(".js-gallery-slide");
      this.totalSlides = this.slides.length;
      this.prevBtnElement = this.$(".js-slide-prev-btn");
      this.nextBtnElement = this.$(".js-slide-next-btn");
      this.currentSlideElement = this.$(".js-slide-current");
      this.totalElement = this.$(".js-slide-total");
      this.paginationElement = this.$(".js-slide-pagination");
      this.currentIndex = 1;
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          this.slides.forEach(el => {
            if (el.dataset.mediaId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.remove("d-none");
              el.classList.add("is-active-gallery-slide", "d-flex");
              let zoomElement = el.querySelector("sht-zoom");
              zoomElement && zoomElement.init();
              this.currentIndex = el.dataset.itemIndex;
              throw "done";
            }
          });
        } catch (e) {}
        this.updateNavigation();
      });

      this.bindEventHandlers();
    }

    updateNavigation() {
      this.currentSlideElement.textContent = this.currentIndex;
      this.totalElement.textContent = this.totalSlides;

      if (this.currentIndex <= 1) {
        this.prevBtnElement.setAttribute("disabled", "disabled");
      } else {
        this.prevBtnElement.removeAttribute("disabled");
      }

      if (this.currentIndex >= this.totalSlides) {
        this.nextBtnElement.setAttribute("disabled", "disabled");
      } else {
        this.nextBtnElement.removeAttribute("disabled");
      }
      if (this.totalSlides > 1) {
        this.paginationElement?.classList.remove("d-none");
        this.paginationElement?.classList.add("d-flex");
      }

      if (this.totalSlides <= 1) {
        this.paginationElement?.classList.remove("d-flex");
        this.paginationElement?.classList.add("d-none");
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}

    bindEventHandlers() {
      this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
      this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      let type = event.currentTarget.name.toLowerCase();
      this.showSlides(type);
    }

    showSlides(type) {
      this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);

      if (this.currentElement) {
        let zoomElement = this.currentElement.querySelector("sht-zoom");
        zoomElement && zoomElement.reset();
      }

      this.slides.forEach(el => {
        el.classList.remove("is-active-gallery-slide", "d-flex");
        el.classList.add("d-none");
      });

      if (type === "next") {
        this.currentIndex = parseInt(this.currentIndex) + 1;
        this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);
        this.currentElement.classList.add("is-active-gallery-slide", "d-flex");
        this.currentElement.classList.remove("d-none");
      }

      if (type === "previous") {
        this.currentIndex = parseInt(this.currentIndex) - 1;
        this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);
        this.currentElement.classList.add("is-active-gallery-slide", "d-flex");
        this.currentElement.classList.remove("d-none");
      }
      this.currentSlideElement.textContent = this.currentIndex;
      this.updateNavigation();

      let activeZoom = this.currentElement.querySelector("sht-zoom");

      this.gallery.playActiveVideo(this.currentElement);
      this.gallery.playActiveModel(this.currentElement);
      if (activeZoom) {
        activeZoom.init();
      }
    }
  }

  customElements.define("sht-gallery-slides", SHTGallerySlides);
}

if (!customElements.get("sht-gallery")) {
  class SHTGallery extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = SHTHelper.qs(`sht-dialog#${this.dataset.galleryDialogId}`);
      this.$$(".js-gallery-btn-thumb").forEach(e => {
        e.addEventListener("click", this.setActiveMedia.bind(this, e));
      });
      this.thumbCarousel = this.$("sht-horiz-carousel");
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          if (window.SHTProductMediaItemModel) {
            window.SHTProductMediaItemModel.loadShopifyXR();
          }
          this.$$(".js-gallery-thumb").forEach(el => {
            if (el.dataset.mediaTargetId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.add("is-active-gallery-thumb");
              this.scrollToThumb(el.dataset.mediaTargetId);
              throw "done";
            }
          });
        } catch (e) {}
      });

      this.dialog.addEventListener("closing", e => {
        this.$$(".js-gallery-thumb").forEach(el => {
          el.classList.remove("is-active-gallery-thumb");
        });
      });
    }

    scrollToThumb(thumbId) {
      let carouselItem = this.thumbCarousel.querySelector(`[data-media-target-id="${thumbId}"]`);

      if (carouselItem) {
        this.thumbCarousel.querySelector(".js-carousel-items").scrollTo({
          left: carouselItem.offsetLeft,
          behavior: "auto",
        });
      }
    }

    setActiveMedia(e) {
      let preActiveMedia = this.$("sht-gallery-slide.is-active-gallery-slide");
      if (preActiveMedia) {
        let zoomElement = preActiveMedia.querySelector("sht-zoom");
        zoomElement && zoomElement.reset();
      }

      let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);

      let activeZoom = activeMedia.querySelector("sht-zoom");

      let activeThumb = e.closest("sht-horiz-carousel-itm");

      this.$$(".js-gallery-slide").forEach(element => {
        element.classList.remove("is-active-gallery-slide", "d-flex");
        element.classList.add("d-none");
      });

      this.$$(".js-gallery-thumb").forEach(element => {
        element.classList.remove("is-active-gallery-thumb");
      });

      activeMedia.classList.add("is-active-gallery-slide", "d-flex");
      activeMedia.classList.remove("d-none");
      activeThumb.classList.add("is-active-gallery-thumb");

      this.playActiveVideo(activeMedia);

      this.playActiveModel(activeMedia);

      if (activeZoom) {
        activeZoom.init();
      }
    }

    pauseAllVideo() {
      this.$$(".js-media-item-youtube").forEach(video => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
      });
      this.$$(".js-media-item-vimeo").forEach(video => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });

      this.$$(".js-media-item-video").forEach(video => video.pause());
    }

    playActiveVideo(activeItem) {
      this.pauseAllVideo();
      let deferredExternalVideo = activeItem.querySelector(".js-product-media-deferred-video");

      if (deferredExternalVideo) deferredExternalVideo.loadContent();
    }

    playActiveModel(activeItem) {
      let deferredExternalModel = activeItem.querySelector(".js-product-media-deferred-model");
      if (deferredExternalModel) {
        deferredExternalModel.loadContent();
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }
  customElements.define("sht-gallery", SHTGallery);
}

if (!customElements.get("sht-cont-deferred")) {
  class SHTContentDeferred extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.template = this.$("template");

        if (!this.template) return;
        let content = this.template.content;
        this.appendChild(content);
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }
  customElements.define("sht-cont-deferred", SHTContentDeferred);
}

if (!customElements.get("sht-pickup-avail")) {
  customElements.define(
    "sht-pickup-avail",
    class SHTPickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.$ = this.querySelector.bind(this);

        if (!this.hasAttribute("available")) return;

        this.errorHtml = this.$("template").content.firstElementChild.cloneNode(true);

        this.onClickRefreshListHandleEvent = this.onClickRefreshListHandleEvent.bind(this);

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = routes.root_url;

        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        let url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            let sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            let button = this.$("button");
            if (button) button.removeEventListener("click", this.onClickRefreshListHandleEvent);
            this.renderError();
          });
      }

      onClickRefreshListHandleEvent(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.$("button").addEventListener("click", this.onClickRefreshListHandleEvent);
      }

      renderPreview(sectionInnerHTML) {
        let drawer = SHTHelper.qs("#drawerPickupAvailability");
        let preview = sectionInnerHTML.querySelector("sht-pickup-avail-prwv");

        drawer && drawer.remove();

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          this.classList.remove("d-block");
          this.classList.add("d-none");
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");
        this.classList.add("d-block");
        this.classList.remove("d-none");
        document.body.appendChild(sectionInnerHTML.querySelector("#drawerPickupAvailability"));
        let button = this.$("button");
        button &&
          button.addEventListener("click", e => {
            SHTHelper.qs("#drawerPickupAvailability").openDrawer(e.target);
          });
      }
    }
  );
}

if (!customElements.get("sht-prd-recom")) {
  class SHTProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("sht-prd-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (SHTDefer.length) SHTDefer.shift().call();
    }
  }

  customElements.define("sht-prd-recom", SHTProductRecommendations);
}

if (!customElements.get("sht-gift-card-recipient-form")) {
  class SHTGiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
      this.i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want`);
      this.i_want_input.disabled = false;
      this.hidden_i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want-hidden`);
      this.hidden_i_want_input.disabled = true;
      this.email_input = this.querySelector(`.js-gift-card-recipient-form-email`);
      this.name_input = this.querySelector(`.js-gift-card-recipient-form-name`);
      this.message_input = this.querySelector(`.js-gift-card-recipient-form-message`);
      this.email_error = this.querySelector(`.js-gift-card-recipient-form-email-error`);

      this.addEventListener("change", this.onChangeHandler.bind(this));
    }

    onChangeHandler() {
      if (!this.i_want_input.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearErrorMessage() {
      this.querySelectorAll(".js-gift-card-recipient-form-error").forEach(field => {
        field.classList.add("hidden");
        let textField = field.querySelector(".error-message");
        if (textField) textField.innerText = "";
      });

      [this.email_input, this.name_input, this.message_input].forEach(inputElement => {
        inputElement.setAttribute("aria-invalid", false);
        inputElement.removeAttribute("aria-describedby");
        inputElement.removeAttribute("tabindex");
      });
    }

    clearInputFields() {
      this.email_input.value = "";
      this.name_input.value = "";
      this.message_input.value = "";
    }

    handleErrorMessage(error, message) {
      Object.entries(error).forEach(([key, value]) => {
        let errorMessageContainer = this.querySelector(`.js-gift-card-recipient-form-${key}-error`);
        let errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
        let input = this.querySelector(`.js-gift-card-recipient-form-${key}`);
        errorMessageContainer.querySelector(".error-message").innerText = value;
        errorMessageContainer.classList.remove("hidden");
        input.setAttribute("aria-invalid", true);
        input.setAttribute("aria-describedby", errorMessageId);
        input.focus();
      });
    }

    resetRecipientForm() {
      if (this.i_want_input.checked) {
        this.i_want_input.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  customElements.define("sht-gift-card-recipient-form", SHTGiftCardRecipientForm);
}
